export function isSafeHref(href: string | undefined): boolean {
  if (!href) return false;

  const value = href.trim();

  // Block backslashes globally to avoid parser differences and URL obfuscation.
  if (value.includes("\\")) return false;

  if (value.startsWith("/")) {
    // Block protocol-relative URLs (e.g. //example.com) to prevent bypassing protocol/auth checks
    if (value.startsWith("//")) return false;
    return true;
  }

  try {
    const url = new URL(value);
    // Block basic auth (username/password) to prevent phishing
    if (url.username || url.password) {
      return false;
    }
    // Enforce HTTPS for external links (security enhancement)
    return url.protocol === "https:";
  } catch {
    return false;
  }
}
